import React from 'react';
import {MyDate} from "../dates/util";

export const name = "Another Decade Rolls In"
export const created_on = new MyDate(2020, 1, 1);

export const mod = () => {
    return (
        <>
            <p>
                I find it pretty weird that 2020 is being called the new
                decade. As a CS guy, I'm totally fine with counts
                starting at zeros (0s), but quick Google Searches point
                to the fact that thereis no 0 AD. So ideally 2021 is the
                new decade, but people be jubilant and let us let them
                be!
            </p>
            <p>
                Well, I totally am in the new decade mode. I bought
                myself a pair bluetooth AudioTechnica which I thoroughly
                enjoyed. AAAAnnd, i ended up getting another pair of Sony
                noise cancelling Headphones later from office. Now I
                have 2 too many headphone. Life. I'll keep one pair in
                office and ramp up the frequency
                of <a href="https://twitter.com/HowIBuiltThis"><span>Guy Raz's HIBT</span></a>.
                It is just insane, particularly the ones about AirBnB
                & Reddit. There is one about WeWork as well. Lol! Considering
                where they are now, and everything that happened in that
                podcast. Let's not go on about it.
            </p>
            <p>
                I've added another 6 months to my work experience from
                my last blog post. That is really odd. I didn't think I'll
                make it to the end of this year at my firm, but it happened.
                In fact, I've started spending more time at work cuz there
                are just so many things to do. Every now and then I talk to
                a few people & FOMO hits like a wrecking ball, but then I
                switch on my Headphones & I'm back.
            </p>
            <p>
                I renewed my Amazon Prime to watch "The Family Man". It is good.
                Then I forgot to cancel my subscription & it aut--renewed.
                Seinfeld showed up on the suggestion list. I watched it.
                And then I just couldn't stop. Episode-after-episode,
                season-after-season. O man! is it a beauty. When S09 rolled
                in I was just depressed. It just left a hole in my life
                which I'm currently filling up with YouTube videos of
                Seinfeld. I just can't not make a Seinfeld reference anymore.
                It is just soooo compatible with life!
            </p>
            <p>
                I've fallen pretty behind on my reading. My goodreads
                "Currently Reading" is just piling up, just like the stack
                on my table. BTW, I got a new UltraWide monitor which I
                am thoroughly enjoying. It has just doubled my productivity!
                PJ, I know. Will not crack another one.
            </p>
            <p>
                This is a new year post and what is a new year post without
                resolutions. I don't have fitness resolution. My parents
                have one, so I'm now doing Surya Namaskar in the morning
                everyday. I need to give daily updates about it as well.
                My resolution is about inflating my developer's portfolio
                by learning new stuff. And that is where my work life comes
                in. I believe that there are a lot of inefficient things
                going on there and I want to fix'em all. I also want to
                step up my competitive coding profile. Come on. Come on.
                I think 2 are good enough. I also have another resolution, but I'm
                not sharing it here, lest I make an ass of myself. But I'll
                need to share it with somebody! Well, I'll sound out and see
                who looks favorable to help me out there.
            </p>
            <p>
                I know that this post looks & feels pretty drab and ranty but
                I seriously don't have much exciting to share.
            </p>
            <p>
                Happy New Year & a great start to a new decade of 2020s.
            </p>
        </>
    );
}
